import { useQuery } from '@tanstack/react-query';
import { useAuth } from '@/contexts/AuthContext';
import { getReviewRequests } from '@/lib/api/reviews/review-requests';

export function useReceivedReviewRequestsQuery() {
  const { user } = useAuth();
  return useQuery({
    queryKey: ['review-requests', user?.id],
    queryFn: async () => {
      if (!user?.id) return [];
      const data = await getReviewRequests(user.id);
      return data.filter((request) => request.status === 'pending');
    },
    enabled: !!user?.id,
  });
}
